import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import {
  Modal,
  View,
  SafeAreaView,
  TouchableOpacity,
  Text,
  Platform
} from 'react-native';
import tw from 'twrnc';

import { iqesColors } from '../../../shared/ui/iqesDesignSystem';

import { RevenueCatSubscriptionScreen } from './RevenueCatSubscriptionScreen';
import { SubscriptionPlansScreen } from './SubscriptionPlansScreen';

interface SubscriptionPlansModalProps {
  visible: boolean;
  onClose: () => void;
  preselectedPlan?: string;
}

export const SubscriptionPlansModal: React.FC<SubscriptionPlansModalProps> = ({
  visible,
  onClose,
  preselectedPlan
}) => {
  // Mobile platforms must use native store billing.
  const useNativeIAP = Platform.OS === 'ios' || Platform.OS === 'android';

  return (
    <Modal
      visible={visible}
      animationType="slide"
      presentationStyle="pageSheet"
      onRequestClose={onClose}
    >
      <SafeAreaView style={[tw`flex-1`, { backgroundColor: iqesColors.canvas }]}>
        {useNativeIAP ? (
          // Mobile: Use RevenueCat for native In-App Purchase / Play Billing
          <RevenueCatSubscriptionScreen
            onSuccess={onClose}
            onClose={onClose}
          />
        ) : (
          // Web: Use hosted checkout flow
          <>
            {/* Modal Header */}
            <View style={tw`flex-row items-center justify-between px-4 py-3 border-b border-gray-200`}>
              <View style={tw`flex-1`}>
                <Text style={tw`text-xl font-bold text-gray-900`}>
                  Choose Your Plan
                </Text>
              </View>

              {/* Close Button */}
              <TouchableOpacity
                onPress={onClose}
                style={tw`p-2 rounded-full bg-gray-100`}
              >
                <Ionicons name="close" size={24} color="#6B7280" />
              </TouchableOpacity>
            </View>

            {/* Subscription Plans Content */}
            <View style={tw`flex-1`}>
              <SubscriptionPlansScreen
                route={{
                  params: {
                    preselectedPlan,
                  }
                }}
                onSubscriptionSuccess={onClose}
              />
            </View>
          </>
        )}
      </SafeAreaView>
    </Modal>
  );
};
